import { useState, useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const useCyprusTime = () => {
  const [now, setNow] = useState(new Date());
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);
  const fmt = new Intl.DateTimeFormat("en-GB", { hour: "2-digit", minute: "2-digit", second: "2-digit", timeZone: "Asia/Nicosia" });
  const hour = parseInt(new Intl.DateTimeFormat("en-GB", { hour: "2-digit", hour12: false, timeZone: "Asia/Nicosia" }).format(now), 10);
  const day = new Intl.DateTimeFormat("en-GB", { weekday: "short", timeZone: "Asia/Nicosia" }).format(now);
  const open = !["Sat", "Sun"].includes(day) && hour >= 8 && hour < 18;
  return { time: fmt.format(now), open };
};

const Segment = ({ label, value, live, accent, flag }) => (
  <div className="flex flex-col justify-center pr-7 mr-7 border-r border-white/10 shrink-0 last:border-r-0 group">
    <span className="flex items-center gap-1.5 font-mono text-[9px] uppercase tracking-[0.22em] text-[#5E6B7D]">
      {live && <span className="w-1.5 h-1.5 bg-[#4ADE80] animate-pulse" />}
      {flag && <span className="w-1.5 h-1.5 bg-[#B85D2A]" />}
      {label}
    </span>
    <span className={`font-mono text-[13px] font-semibold tracking-wider mt-0.5 transition-colors duration-300 ${accent ? "text-[#4ADE80]" : "text-[#FBF9F5] group-hover:text-[#B85D2A]"}`}>
      {value}
    </span>
  </div>
);

export const TechStrip = () => {
  const { time, open } = useCyprusTime();
  const [rates, setRates] = useState(null);

  useEffect(() => {
    axios.get(`${API}/widgets/rates`).then((r) => setRates(r.data)).catch(() => {});
  }, []);

  return (
    <div className="bg-[#142D44] border-t-2 border-t-[#B85D2A] border-b border-white/10" data-testid="tech-strip">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center overflow-x-auto">
        <Segment label="Nicosia / Cyprus" value={time} live />
        <Segment label="Advisory Desk" value={open ? "OPEN" : "CLOSED"} accent={open} />
        {rates?.rates && Object.entries(rates.rates).map(([cur, val]) => (
          <Segment key={cur} label={`EUR / ${cur}`} value={Number(val).toFixed(4)} flag />
        ))}
        {rates?.date && <Segment label="ECB Reference" value={rates.date} />}
        <div className="ml-auto hidden xl:flex items-center gap-2 shrink-0 pl-6">
          <span className="w-2 h-2 bg-[#B85D2A]" />
          <span className="font-mono text-[10px] tracking-[0.25em] text-[#5E6B7D]">HORIZON ADVISORS · LIVE DESK</span>
        </div>
      </div>
    </div>
  );
};
